export const FeatureFlag = {
  RegistrationOpen: 'registration-open',
  DebugInfo: 'debug-info',
  DemoData: 'demo-data',
  StatusBar: 'status-bar',
  Drawer: 'drawer',
  SecondaryBar: 'secondary-bar',
  Trips: 'trips',
  SidebarGear: 'sidebar-gear',
  Subscriptions: 'subscriptions',
  AiPackBuilder: 'ai-pack-builder',
  ChaosImport: 'chaos-import',
  DevArea: 'dev-area',
  DebugAuth: 'debug-auth',
  DebugForms: 'debug-forms',
  DebugGrid: 'debug-grid',
  WhatsNew: 'whats-new',
} as const;
